module.exports = __webpack_public_path__ + "img/author_icon.9c528a5a.png";